import Container from "react-bootstrap/Container";
import React, { useEffect, useState } from 'react';
import '../../components/ContactSection.css';
import './Contact.css';
import upIcon from "../../assets/images/up.png";
import { ContactSection } from "../../components/ContactSection";

export const Contact = () => {
    const [isVisible, setIsVisible] = useState(false);

    // This useEffect listens to the window scroll event
    useEffect(() => {
        window.scrollTo(0, 0);

        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const jumpHome = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className="contactSection" id="contactsSectionId">
            <div className="masthead-contact">
                <div className="logo-services">
                    <h1 className="logo-services-title">Contact</h1>
                </div>
            </div>
            {isVisible && (
                <button className="floatingButton" onClick={jumpHome}>
                    <img className="up" src={upIcon} alt="up arrow icon" />
                </button>
            )}
            <Container>
                <ContactSection />
            </Container>
            <br />
            <h4>Copyright 2025 Streetlink Homeless Support.</h4>
            <br />
        </div>
    );
}
